(function (app) {

    app.provider("planTypeApi",
        [
            function () {
                this.$get = [
                    "crmApiGateway", function (crmApiGateway) {
                        var service = {};
                        //GETs
                        service.getPlanType = (planTypeId) => {
                            return crmApiGateway.get(`/PlanTypes/${planTypeId}`);
                        };

                        service.getPlanTypes = function () {
                            return crmApiGateway.getArray("/PlanTypes");
                        }

                        //PUTs
                        service.updatePlanType = (planTypeId, planType) => {
                            return crmApiGateway.put(`/PlanTypes/${planTypeId}`, planType);
                        };

                        //POSTs
                        service.createPlanType = (planType) => {
                            return crmApiGateway.post("/PlanTypes", planType);
                        };

                        return service;
                    }
                ];
            }
        ]);
})(window.app); //jshint ignore:line